export default __webpack_public_path__ + "static/media/Val.9f8e9ea4.png";